import { render, staticRenderFns } from "./WidgetTypeSelector.vue?vue&type=template&id=2f5a2c26"
import script from "./WidgetTypeSelector.vue?vue&type=script&lang=js"
export * from "./WidgetTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./WidgetTypeSelector.vue?vue&type=style&index=0&id=2f5a2c26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports